import { computed, ref } from "vue";

export function usePageLazyLoad(fetchFunction, initialPage = 1, perPage = 1) {
  const data = ref([]);
  const currentPage = ref(initialPage);
  const lastPage = ref(null);
  const isLoading = ref(false);
  const error = ref(null);

  const loadNextPage = async () => {
    if (
      isLoading.value ||
      (lastPage.value && currentPage.value > lastPage.value)
    )
      return;

    isLoading.value = true;
    error.value = null;

    try {
      const response = await fetchFunction({
        pagination: {
          page: currentPage.value,
          per_page: perPage,
        },
      });

      const { meta, data: reponseData } = response;

      data.value.push(...(reponseData || []));

      currentPage.value = meta.current_page + 1;
      lastPage.value = meta.last_page;
    } catch (err) {
      error.value =
        err?.response?.data?.message ||
        "Er is iets misgegaan bij het ophalen van de gegevens.";
    } finally {
      isLoading.value = false;
    }
  };

  const hasMore = computed(
    () => !lastPage.value || currentPage.value <= lastPage.value,
  );

  return {
    data,
    loadNextPage,
    isLoading,
    error,
    hasMore,
  };
}
